export interface SpinnerProps {
  /** 何を待っているかを読み上げへ伝える。 */
  label: string;
}

/** 読み込み中の表示。図形だけだと読み上げに何も伝わらないのでaria-labelを必ず持たせる。 */
export function Spinner({ label }: SpinnerProps) {
  return <span className="spinner" role="status" aria-label={label} />;
}
